import React, { useState } from 'react';
import AuthLayout from '../Layouts/authLayout';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { sendForgotLink } from '../../actions/userActions';
import { toast } from 'react-toastify';
import Typography from '@material-ui/core/Typography';
import LoadingView from '../Loader/LoadingView';
import { PORTAL } from '../../config';

const styles = {
	logo : {
		width  : '100%',
		height : 'auto'
	},
	'btnColor' : {
		background
		: '#0F9710',
		color
		: 'white',
		fontWeight
		: 'bold'
	},
	'btnColorProd' : {
		backgroundColor
		: '#b1e3fa',
		color
		: 'black',
		fontWeight
		: 'bold'
	},
	'fullWidth' : {
		width
		: '100%'
	}
};
const ForgotPasswordPage = ({ classes }) =>
{
	const [ loading, setLoading ] = useState(false);

	const [ sent, setSent ] = useState(false);

	const handleSubmit = (event) =>
	{
		event.preventDefault();
		const data = new FormData(event.currentTarget);

		const obj = {
			email : data.get('email')
		};

		if (obj.email && obj.email.trim() !== '')
		{
			if (!loading)
			{
				setLoading(true);
				sendForgotLink(obj).then(() =>
				{
					setSent(true);
					setLoading(false);
					// toast.alert('Password reset link sent to your registered mail id');
					// history.push('/');
				})
					.catch((err) =>
					{
						// eslint-disable-next-line no-console
						console.log('err ===== ', err);
						toast.error('Internal Server Error, Please try again');
						setLoading(false);
					});
			}
		}
		else
		{
			// alert("Please ener the User Name and Password");
			toast.error('Please enter the email');
		}
	};

	return (
		<Container component='main' maxWidth='xs' className={classes.root}>
			<CssBaseline />
			{loading && <LoadingView />}
			<Box
				sx={{
					display       : 'flex',
					flexDirection : 'column'
				}}
			>
				{
					sent ?
						<>
							<Typography className={`${PORTAL=='WORLD'?'whiteTxt':''}`}>
								Password reset link sent to your registered mail id
							</Typography>
							<Grid container>
								<Grid item xs>
									<Link to='/' variant='body2' className={`txtDecorationNone ${PORTAL=='WORLD'?'whiteTxt':'txtColorBlackL' }`}>
										<b>OK</b>
									</Link>
								</Grid>
							</Grid>
						</>
						:
						<>
							<span className={`subHeadingSM ${PORTAL=='WORLD'?'whiteTxt':''}`}><b>Please enter your registered email address</b></span>
							<Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
								<TextField
									variant='outlined'
									margin='normal'
									required
									fullWidth
									id='email'
									placeholder='Email'
									name='email'
									autoFocus
									InputLabelProps={{
										style : { color: '#fff' }
									}}
									className='inputField'
								/>
								<div className='flexAutoCol mrgnVSM'>
									<Button
										type='submit'
										fullWidth
										variant='contained'
										className={PORTAL=='WORLD'?classes.btnColorProd:classes.btnColor}
									>
										Submit
									</Button>
								</div>
								<Grid container>
									<Grid item xs>
										<Link to='/' variant='body2' className='txtColorBlackL txtDecorationNone'>
											<b className={PORTAL=='WORLD'?'whiteTxt':'txtColorBlackL'}>Go Back</b>
										</Link>
									</Grid>
								</Grid>
							</Box>
						</>
				}
			</Box>
		</Container>
	);
};

export default AuthLayout(withStyles(styles)(ForgotPasswordPage));